import { catchError, map } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { DatePipe } from "@angular/common";
import { HttpHeaders, HttpClient } from "@angular/common/http";
import { throwError as observableThrowError, Observable } from "rxjs";
import { ApiService } from "./provider/api.service";
import { promisify } from "util";
import { PinConfig } from "./PinConfig";
//import { Buffer } from 'buffer';
@Injectable({
  providedIn: "root",
})
export class ConstService {
  constructor(private datePipe: DatePipe, private apiService: ApiService) {}
  //////////////////CRONTAB////////////////
  // */2 * * * * curl http://10.143.0.34:30001/kaabu-engine-pc/identification/update-client-kaabu
  // */2 * * * * curl http://10.143.0.34:30001/kaabu-engine-pc/identification/update-client-kaabu-omy
  // */2 * * * * curl http://10.143.0.34:30001/kaabu-engine-pc/identification/update-compte-kaabu
  //  */2 * * * * curl http://10.143.0.34:30001/kaabu-engine-pc/identification/update-client-kaabu-omy?type=SIGNATURE
  //  */2 * * * * curl http://10.143.0.34:30001/kaabu-engine-pc/identification/update-compte-kaabu?type=SIGNATURE
  //  */2 * * * * curl http://10.143.0.34:30001/kaabu-engine-pc/identification/update-compte-kaabu?type=SIGNATURE_REJETER
  //  */2 * * * * curl http://10.143.0.34:30001/kaabu-engine-pc/identification/update-client-kaabu-omy?type=SIGNATURE_REJETER
  // 0 1 * * * curl http://10.143.0.34:30003/kaabu-engine-encaissement/vacations/cron/fermer
  // chaque 1h curl http://10.143.0.34:30020/kaabu-interface-crm/select-facture-cron
  // chaque 1h05 curl http://10.143.0.34:30020/kaabu-interface-crm/envoyer-facture-cron
  // chaque Lundi 20h curl http://10.143.0.34:30004/kaabu-vente-service/offre-services/op/faire-depot?f=2
  // chaque mois (le 01 à 20h) curl http://10.143.0.34:30004/kaabu-vente-service/offre-services/op/faire-depot?f=3
  //chaque jour 20h curl http://10.143.0.34:30003/kaabu-engine-encaissement/avoir/cron/right-off
  //chaque jour 20h05 curl http://10.143.0.34:30003/kaabu-engine-encaissement/interdictions-cheques/cron/lever-interdiction
  //chaque 1h curl http://10.143.0.34:30001/kaabu-engine-pc/factures/cron-retablissement-auto
  Dico = {
    BOUTIQUE_ORANGE: "BOUTIQUE_ORANGE",
    BRONZE: "BRONZE",
    SYLVER: "SYLVER",
    PLATINUM: "PLATINUM",
    TAUX_ECHANGE: "TAUX_ECHANGE",
    TAUX_ECHANGE_PUE: "TAUX_ECHANGE_PUE",
    TAUX_AUTRES_TAXES: "TAUX_AUTRES_TAXES",
    TAUX_TVA: "TAUX_TVA",
    SESSION_AGENT_TYPE_AGENCE: "SESSION_AGENT_TYPE_AGENCE",
    PERSONNE: "PERSONNE",
    ORGANISATION: "ORGANISATION",
    ENTREPRISE: "ENTREPRISE",
    ENCRYPTION_PASS: "OZBANpppppPMM@uniquefordandcmanti2108",
  };
  get MAP_KEY() {
    return "AIzaSyA10CXz5zPql5YUKxW8FR_YVYYQ8Cs1GI8";
    //return 'AIzaSyAdRxjNZ9TooAS-qzMajbCY4yeSP0-Qif4';
  }
  get versionAppli() {
    return "4.4.5";
  }

  // http://10.143.0.2:32300
  get baseUrlDistri() {
    // return "http://10.143.156.2:30049";
    return "https://distriapi.orange.cd";
    // return "https://ocdkaabuapp.orangerdc.cd:30049";
    //return "http://localhost:3555";
  }

  get baseUrl() {
    //return "http://localhost:8070/kaabu-engine-admin";
    // return "http://10.143.156.2:30002/kaabu-engine-admin";
    //return "http://10.143.0.34:30002/kaabu-engine-admin";
    return "https://ocdkaabuapp.orangerdc.cd:30002/kaabu-engine-admin";
  }

  get baseUrlPC() {
    //return "http://localhost:7072/kaabu-engine-pc";
    // return "http://10.143.156.2:30001/kaabu-engine-pc";
    //return "http://10.143.0.34:30001/kaabu-engine-pc";
    return "https://ocdkaabuapp.orangerdc.cd:30001/kaabu-engine-pc";
  }

  get baseUrlOTPApi() {
    //return "http://localhost:9090";
    //return "http://localhost:8070/kaabu-engine-admin";
    // return "http://10.143.156.2:30002/kaabu-engine-admin";
    return "https://ocdkaabuapp.orangerdc.cd:30070";
  }

  get baseUrlVente() {
    //return "http://localhost:8050/kaabu-vente-service";
    // return "http://10.143.156.2:30004/kaabu-vente-service";
    //return "http://10.143.0.34:30004/kaabu-vente-service";
    return "https://ocdkaabuapp.orangerdc.cd:30004/kaabu-vente-service";
    // return "http://10.172.1.109:32330/kaabu-vente-service"
  }

  get baseUrlEncaiss() {
    //return "http://localhost:8075/kaabu-engine-encaissement";
    // return "http://10.143.156.2:30003/kaabu-engine-encaissement";
    return "http://10.143.0.34:30003/kaabu-engine-encaissement";
    // return "https://ocdkaabuapp.orangerdc.cd:30003/kaabu-engine-encaissement";
  }

  get baseUrlOffreAdmin() {
    // return "http://localhost:8060/kaabu-offre-admin";
    // return "http://10.143.156.2:30006/kaabu-offre-admin";
    // return "http://10.143.0.34:30006/kaabu-offre-admin";
    return "https://ocdkaabuapp.orangerdc.cd:30006/kaabu-offre-admin";
  }

  get baseUrlFtth() {
    // return "http://localhost:8287/si-ftth";
    // return "http://10.143.156.2:30030/si-ftth";
    // return "http://10.143.0.34:30030/si-ftth";
    return "https://ocdkaabuapp.orangerdc.cd:30030/si-ftth";
  }

  get baseUrlFtthPc() {
    // return "http://10.143.156.2:30030/si-ftth";
    // return "http://10.143.0.34:30030/si-ftth";
    return "https://ocdkaabuapp.orangerdc.cd:30030/si-ftth";
  }

  get baseUrlRecouv() {
    //return "http://localhost:8074/kaabu-engine-recouvrement";
    // return "http://10.143.156.2:30005/kaabu-engine-recouvrement";
    //return "http://10.143.0.34:30005/kaabu-engine-recouvrement";
    return "https://ocdkaabuapp.orangerdc.cd:30005/kaabu-engine-recouvrement";
  }

  get baseUrlOpenStack(): string {
    //return "http://10.143.156.2:30031/openstack";
    //return "http://10.143.0.34:30031/openstack";
    // https://applidistri.orangemali.com:32111/commandes/image?image=commande_img_20210812112531_0.jpg
    return "https://ocdkaabuapp.orangerdc.cd:30031/openstack";
    // return "http://10.172.19.61:32240/openstack";
    // return "https://applidistri.orangemali.com:32111/commandes/image?image=";
  }

  get baseUrlSearch() {
    //return "http://10.172.101.123:8078/kaabu-engine-search";
    //return "http://10.172.1.162:8078/kaabu-engine-search";
    //return "http://10.172.1.109:8078/kaabu-engine-search";
    return "http://localhost:8078/kaabu-engine-search";
    //return "http://10.172.212.208:32063/kaabu-engine-search";
    //return "https://kaabuv2.orangemali.local:32063/kaabu-engine-search";
    //return "https://10.177.45.135:32063/kaabu-engine-search";
    //return "http://10.172.212.75:32063/kaabu-engine-search";
    //return "http://10.172.212.234:32063/kaabu-engine-search";
    //http://localhost:8078/kaabu-engine-search/find/clients?q=maiga
  }
  get baseUrlTraficIN() {
    //return "http://10.172.101.123:8053/kaabu-trafic-in";
    //return "http://10.172.1.109:8053/kaabu-trafic-in";
    return "http://localhost:8053/kaabu-trafic-in";
    //return "http://10.172.212.208:32070/kaabu-trafic-in";
    //return "https://kaabuv2.orangemali.local:32070/kaabu-trafic-in";
    //return "https://10.177.45.135:32070/kaabu-trafic-in";
    //return "http://10.172.212.75:32070/kaabu-trafic-in";
    //return "http://10.172.212.234:32070/kaabu-trafic-in";
  }
  get baseUrlElastic() {
    return "http://10.172.212.104:9200/kaabu";
    // return "http://localhost:9200/kaabu";
  }

  get baseUrlReporting() {
    //return "http://10.175.2.52:8077/kaabu-engine-reporting";
    //return 'http://localhost:8077/kaabu-engine-reporting';
    //return 'http://10.172.218.134:32045/kaabu-engine-reporting';
    //return 'http://10.143.0.21:8077/kaabu-engine-reporting';
    return "https://ocdkaabuapp.orangerdc.cd:8077/kaabu-engine-reporting";
  }
  get baseUrlUpdateBases() {
    return "https://ocdkaabuapp.orangerdc.cd:8077/kaabu-engine-reporting";
    //return 'http://10.172.101.233:8076/updateBases';
    //return 'http://localhost:8076/updateBases';
    //return 'https://kaabuv2.orangemali.local:8076/updateBases';
    //return 'https://10.177.45.135:8076/updateBases';
    // clouds
    //return "https://kaabuv2.orangemali.local:32024/kaabu-engine-reporting";
    //return 'http://10.172.212.75:32024/kaabu-engine-reporting';
  }
  imageUrlOpenStack(pieceName: string): string {
    return (
      this.baseUrlOpenStack +
      "/afficher?nom-image=" +
      pieceName +
      "&container=kaabuv2&type-fichier=image"
    );
    // return this.baseUrlOpenStack + pieceName ;
  }
  imageUrlOpenStackKYC(pieceName: string): string {
    return (
      this.baseUrlOpenStack +
      "/afficher?nom-image=" +
      pieceName +
      "&container=kyc_container&type-fichier=image"
    );
    // return this.baseUrlOpenStack + pieceName ;
  }
  imageUrlOpenStackContainer(pieceName: string, container: string): string {
    return (
      this.baseUrlOpenStack +
      "/afficher?nom-image=" +
      pieceName +
      "&container=" +
      container +
      "&type-fichier=image"
    );
  }
  pdfUrlOpenStack(pieceName: string): string {
    return (
      this.baseUrlOpenStack +
      "/afficher?nom-image=" +
      pieceName +
      "&container=kaabuv2&type-fichier=pdf"
    );
  }
  baseUrlRecouvUploadElagage(login: string) {
    //return "http://localhost:8070/kaabu-engine-recouvrement/elagage/uploadElagage?login="+login;
    return this.baseUrlRecouv + "/elagage/uploadElagage?login=" + login;
  }

  notifier(msg: string) {
    /*
    return this.apiService.get(this.baseUrlVente + "/transferts/notifier?n=" + msg, this.baseOption).pipe(
      map(res => res),
      catchError(this.handleError));
    */
  }
  /*
  get baseUrlInterfaceCrm() {
        //return "http://localhost:8055/kaabu-interface-crm";
        //return "http://10.172.212.208:32064/kaabu-interface-crm";
        return "http://10.172.212.75:32064/kaabu-interface-crm";
  }
  get baseUrlOmyGatway() : string {
        return "http://10.172.1.109:7065/omygatway";
        //return "http://10.172.1.183:7045/OMYGateway";
  }
  get baseUrlOcr() {
        return "http://10.172.1.109:8888/ocr-api/ocr/upload";
  }
  //http://10.172.212.70:32542/kaabu-provisioning/provisioning-request/provisionning-process
  //http://10.172.101.123:8069/kaabu-provisioning/provisioning-request/provisionning-process
  get baseUrlOffre() {
        //return "http://10.172.212.49:9000/offre-pro";
        //return "http://10.172.1.109:9000/offre-pro";
        return "http://localhost:9000/offre-pro";
        //return "http://10.172.1.109:9005/offre-flotte";
  }
  */
  get baseUrlOffreBilling() {
    //return "http://localhost:8091/kaabu-engine-billing";
    //return "http://10.143.0.21:8091/kaabu-engine-billing";
    return "https://ocdkaabuapp.orangerdc.cd:8091/kaabu-engine-billing";
  }
  get baseUrlOffreValo() {
    return "http://localhost:7076/kaabu-valo-orchestrator/valos";
    // return "http://10.172.1.228:7076/kaabu-valo-orchestrator/valos";
    //return "http://10.172.218.185:7076/kaabu-valo-orchestrator/valos";
    //return "https://kaabuv2.orangemali.local:7076/kaabu-valo-orchestrator/valos";
  }
  get baseUrlBillingStarter() {
    //return "http://10.172.101.123:9090//billing-starter";
    // return "http://10.172.1.162:9090/billing-starter";
    //  return "http://10.172.101.233:9090/billing-starter";
    // return "http://localhost:9090/billing-starter";
    //  return "http://10.172.1.162:9090/billing-starter";
    //   return "http://localhost:8090/kaabu-engine-billing";
    // return "http://10.172.212.161:32055/kaabu-engine-billing";
    //  return "http://10.172.212.234:32055/kaabu-engine-billing";
    //return "http://localhost:9090/billing-starter";
    // return "http://10.143.0.21:9091/billing-starter";
    return "https://ocdkaabuapp.orangerdc.cd:9091/billing-starter";
  }
  get uploadmsisdn() {
    //return "http://10.172.101.123:8070/kaabu-engine-admin";
    //return "http://10.172.1.109:8070/kaabu-engine-admin";
    return this.baseUrlOffreBilling + "/billing/upload-msisdns";
    // return "http://10.172.101.233:8090/kaabu-engine-billing/billing/upload-msisdns";
  }
  get urluploadapplicationremise() {
    //return "http://10.172.101.123:8070/kaabu-engine-admin";
    //return "http://10.172.1.109:8070/kaabu-engine-admin";
    //   return "http://10.172.101.233:8090/kaabu-engine-billing/billing/upload-applicationremise";
    return this.baseUrlOffreBilling + "/billing/upload-applicationremise";
    //return "https://kaabuv2.orangemali.local:8090/kaabu-engine-billing/billing/upload-applicationremise";
  }
  get uploadmsisdntrial() {
    //return "http://10.172.101.123:8070/kaabu-engine-admin";
    //return "http://10.172.1.109:8070/kaabu-engine-admin";
    //  return "http://10.172.101.233:8090/kaabu-engine-billing/billing/upload-msisdns-trial";
    return this.baseUrlOffreBilling + "/billing/upload-msisdns-trial";
    //return "https://kaabuv2.orangemali.local:8090/kaabu-engine-billing/billing/upload-msisdns-trial";
  }
  get uploadMailing() {
    //return "http://10.172.101.123:8070/kaabu-engine-admin";
    //return "http://10.172.1.109:8070/kaabu-engine-admin";
    // return "http://10.172.101.233:8090/kaabu-engine-billing/billing/upload-mailing";
    return this.baseUrlOffreBilling + "/billing/upload-mailing";
    //return "https://kaabuv2.orangemali.local:8090/kaabu-engine-billing/billing/upload-mailing";
  }
  ///////////////////////////// END /////////////////////////////
  get messageDroitFonctionnalite() {
    return "Vous n'avez pas droit à la fonctionnalité. Veuillez contacter votre Administrateur !";
  }
  get baseOptionBlob() {
    let myheaders = new HttpHeaders();
    myheaders.append("Content-Type", "application/json");
    myheaders.set(
      "Authorization",
      `Basic ${sessionStorage.getItem("SESSION_TOKEN")}`
    );
    let options = { headers: myheaders, responseType: "blob" } as any;
    return options;
  }
  get baseOption() {
    let head = new HttpHeaders({ "Content-Type": "application/json" });
    //let token = btoa('ksidatym:e94f747441be861c35c7a3c26b9929db');
    //let token = btoa('kaabu_system:beb066564373107b1bfb086187ecf591');
    //let token = btoa('amaiga:afbfd34a6979d7f581f42f43a8ebc5d9');
    //let token = btoa('amaiga:Orange2017');
    let token = sessionStorage.getItem("SESSION_TOKEN");
    console.log("***************token 2: ***********", token);
    if (token === null) token = "";
    head = head.set("Authorization", `Basic ${token}`);
    return { headers: head } as any;
    // pass : afbfd34a6979d7f581f42f43a8ebc5d9 ==> Orange2016!
  }
  get baseOptiontext() {
    let myheaders = new HttpHeaders();
    myheaders.append("Content-Type", "application/json");
    myheaders.set(
      "Authorization",
      `Basic ${sessionStorage.getItem("SESSION_TOKEN")}`
    );
    let options = { headers: myheaders, responseType: "text" } as any;
    return options;
  }
  get baseOptionFormData() {
    let head = new HttpHeaders({ enctype: "multipart/form-data" });
    let token = sessionStorage.getItem("SESSION_TOKEN");
    head.set("Authorization", `Basic ${token}`);
    return { headers: head };
  }
  get baseOptionTraficIN() {
    let head = new HttpHeaders({ "Content-Type": "application/json" });
    let token = btoa("traficin:Orange2017");
    head.set("Authorization", `Basic ${token}`);
    return { headers: head };
  }
  get baseOptionOld() {
    let head = new HttpHeaders({ "Content-Type": "application/json" });
    //let token = btoa('ksidatym:e94f747441be861c35c7a3c26b9929db');
    //let token = btoa('kaabu_system:beb066564373107b1bfb086187ecf591');
    //let token = btoa('amaiga:afbfd34a6979d7f581f42f43a8ebc5d9');
    //let token = btoa('amaiga:Orange2017');
    let token = sessionStorage.getItem("SESSION_TOKEN");
    if (token === null) token = "";
    head.set("Authorization", `Basic ${token}`);
    return { headers: head };
    //pass : afbfd34a6979d7f581f42f43a8ebc5d9 ==> Orange2016!
  }
  /*
  get baseOptionOld()  {
        let head = new Headers({'Content-Type': 'application/json'});
        let token = btoa('kaabu_system:beb066564373107b1bfb086187ecf591');
        head.set('Authorization', `Basic ${token}`);
        return {headers: head} ;
        //pass : afbfd34a6979d7f581f42f43a8ebc5d9 ==> Orange2016!
        //65a611e69c4d1bb6d6bb9580a7fed26e
  }
  */
  newBaseOption(login: string) {
    let token = btoa(login + ":Orange2017");
    let head = new HttpHeaders({ "Content-Type": "application/json" });
    if (token === null) token = "";
    head.set("Authorization", `Basic ${token}`);
    return { headers: head };
  }
  generateSession(login: string) {
    let ss = login + "_" + new Date().getTime();
    ss = ss.replace(/\s/g, "");
    return btoa(ss);
  }
  get currentSessionId() {
    return localStorage.getItem("SESSION_IDENTIFIANT");
  }
  get currentProfil() {
    return sessionStorage.getItem("SESSION_AGENT_PROFIL");
  }
  get currentLogin() {
    return sessionStorage.getItem("SESSION_AGENT_LOGIN");
  }
  get currentAgent() {
    return sessionStorage.getItem("SESSION_AGENT");
  }
  get currentPoint() {
    return sessionStorage.getItem("SESSION_AGENT_POINT");
  }
  get currentPointCode() {
    return sessionStorage.getItem("SESSION_AGENT_POINT_CODE");
  }
  get currentRoleDistri() {
    return sessionStorage.getItem("SESSION_AGENT_ROLE_DISTRI");
  }
  get currentAgentB2b(): boolean {
    if (
      sessionStorage.getItem("SESSION_AGENT_B2B") === "true" ||
      sessionStorage.getItem("SESSION_AGENT_B2B") == "1"
    ) {
      return true;
    }
    return false;
  }
  get currentAgentB2c(): boolean {
    if (
      sessionStorage.getItem("SESSION_AGENT_B2C") === "true" ||
      sessionStorage.getItem("SESSION_AGENT_B2C") == "1"
    ) {
      return true;
    }
    return false;
  }
  get idMagasinPricipal(): number {
    return 1;
  }

  get generateIdTransactionEncais(): string {
    var date = new Date();
    //var seconds = (date.getSeconds() < 9)? "0"+date.getSeconds() : date.getSeconds();
    var minutes =
      date.getMinutes() <= 9 ? "0" + date.getMinutes() : date.getMinutes();
    var hour = date.getHours() <= 9 ? "0" + date.getHours() : date.getHours();
    var year =
      date.getFullYear() <= 9 ? "0" + date.getFullYear() : date.getFullYear();
    var month = date.getMonth() + 1;
    var month2 = month <= 9 ? "0" + month : month;
    var day = date.getDate() <= 9 ? "0" + date.getDate() : date.getDate();
    return (
      this.currentLogin +
      "_" +
      year +
      "" +
      month2 +
      "" +
      day +
      "" +
      hour +
      "" +
      minutes
    );
  }

  /*
  get nombreSimPrepaidMax() : number {
        return 10000000;
  }
  get nombreSimIewMax() : number {
        return 3;
  }
  */
  get currentAgentParametreIntrouvable(): boolean {
    let magasin = sessionStorage.getItem("SESSION_AGENT_MAGASIN_ID");
    let login = this.currentLogin;
    if (
      magasin === null ||
      magasin === undefined ||
      magasin === "null" ||
      magasin === "undefined" ||
      magasin === "0" ||
      magasin === "" ||
      login === null ||
      login === undefined ||
      login === "null" ||
      login === "undefined" ||
      login === "0" ||
      login === ""
    ) {
      return true;
    } else {
      return false;
    }
  }
  get currentAgentSignatureIntrouvable(): boolean {
    let magasin = sessionStorage.getItem("SESSION_AGENT_SIGNATURE_NAME");
    if (
      magasin === null ||
      magasin === undefined ||
      magasin === "null" ||
      magasin === "undefined" ||
      magasin === "0" ||
      magasin === ""
    ) {
      return true;
    } else {
      return false;
    }
  }
  get messageParametreIntrouvable() {
    return "Attention! Des paramètres obligatoires sont introuvables sur votre page. Merci de vous reconnecter.";
  }
  hasDroit(flag: string): boolean {
    let droits = sessionStorage.getItem("SESSION_AGENT_DROITS");
    if (droits === null || droits === undefined || droits === "") {
      return false;
    }
    return droits.includes(flag);
  }
  hasDroitValidationKYC(): boolean {
    let ss: string = sessionStorage.getItem(
      this.Dico.SESSION_AGENT_TYPE_AGENCE
    );
    if (ss === null || ss === undefined || ss === "") {
      return false;
    }
    console.log(">>>>type agence=" + ss);
    if (
      ss === this.Dico.BOUTIQUE_ORANGE ||
      ss === this.Dico.PLATINUM ||
      ss === this.Dico.SYLVER
    ) {
      return true;
    }
    return false;
  }
  get growlDefaultLife(): number {
    return 10000;
  }
  get maxSizePaginate(): number {
    return 1000000;
  }
  tauxEchelonnementValue: number = 5;
  get tauxEchelonnement(): number {
    return this.tauxEchelonnementValue;
  }
  setTauxEchelonnement(val) {
    this.tauxEchelonnementValue = val;
  }
  tvaValue: number = 16;
  get tva(): number {
    return this.tvaValue;
  }
  setTva(val) {
    this.tvaValue = 16;
  }
  get regexAlphab() {
    return "^\\S.+$";
  }
  get regexEmail() {
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  }
  get regexNumber() {
    return "^[0-9]+$";
  }
  get regexNumberDouble() {
    return "^[0-9]+(.[0-9]+)?$";
  }
  get regexAlphabOnly() {
    return /^[a-zA-Z ]*$/;
  }
  get regexTelephone() {
    return "^(|243|00243|\\+243)[8][0459]([0-9]){7}$";
  }
  get regexTelephone2() {
    return /^[8][0459]([0-9]){7}$/;
  }
  get regexPassword() {
    return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$^+=!*()@%&]).{12,100}$/;
  }
  get custumDateFr() {
    return {
      firstDayOfWeek: 0,
      monthNames: [
        "Janvier",
        "Février",
        "Mars",
        "Avril",
        "Mai",
        "Juin",
        "Juillet",
        "Août",
        "Septembre",
        "Octobre",
        "Novembre",
        "Décembre",
      ],
      monthNamesShort: [
        "Janv.",
        "Févr.",
        "Mars",
        "Avr.",
        "Mai",
        "Juin",
        "Juil.",
        "Août",
        "Sept.",
        "Oct.",
        "Nov.",
        "Déc.",
      ],
      dayNames: [
        "Dimanche",
        "Lundi",
        "Mardi",
        "Mercredi",
        "Jeudi",
        "Vendredi",
        "Samedi",
      ],
      dayNamesShort: ["Dim.", "Lun.", "Mar.", "Mer.", "Jeu.", "Ven.", "Sam."],
      dayNamesMin: ["D", "L", "M", "M", "J", "V", "S"],
    };
  }
  localeDateString(val: any): any {
    if (val === null || val === undefined) {
      return null;
    }
    if (typeof val === "string") {
      return val;
    } else {
      //return  (new Date(Date.parse(val))).toLocaleDateString();
      return this.datePipe.transform(val, "dd/MM/yyyy");
    }
  }
  localeDateString2(val: any): any {
    if (val === null || val === undefined) {
      return null;
    }
    if (typeof val === "string") {
      return val;
    } else {
      let d = this.datePipe.transform(val, "dd/MM/yyyy"); //(new Date(Date.parse(val))).toLocaleDateString();
      if (d === "01/01/1970") {
        return "";
      } else {
        return d;
      }
    }
  }
  localeDateString3(val: any): any {
    if (val === null || val === undefined) {
      return "";
    }
    if (typeof val === "string") {
      return val;
    } else {
      //return  (new Date(val)).toLocaleDateString();
      return this.datePipe.transform(val, "dd/MM/yyyy");
    }
  }
  localeDateString4(val: any): any {
    return val ? this.datePipe.transform(val, "dd/MM/yyyy") : null;
  }
  convertDateToString(val: any): any {
    if (val === null || val === undefined || val === "") {
      return "";
    }
    if (val.getTime() === 0) {
      return "";
    }
    return this.localeDateString(val);
  }
  getDateTimeNumero() {
    var date = new Date();
    var seconds =
      date.getSeconds() < 9 ? "0" + date.getSeconds() : date.getSeconds();
    var minutes =
      date.getMinutes() < 9 ? "0" + date.getMinutes() : date.getMinutes();
    var hour = date.getHours() < 9 ? "0" + date.getHours() : date.getHours();
    var year =
      date.getFullYear() < 9 ? "0" + date.getFullYear() : date.getFullYear();
    var month = date.getMonth() + 1;
    var month2 = month < 9 ? "0" + month : month;
    var day = date.getDate() < 9 ? "0" + date.getDate() : date.getDate();
    return (
      year +
      "" +
      month2 +
      "" +
      day +
      "" +
      "" +
      hour +
      "" +
      minutes +
      "" +
      seconds
    );
  }
  public cloneObject(source, clone) {
    for (let prop in source) {
      clone[prop] = source[prop];
    }
    return clone;
  }
  public isObjectsEquals(a, b) {
    var isOK = true;
    for (var prop in a) {
      if (a[prop] !== b[prop]) {
        isOK = false;
        break;
      }
    }
    return isOK;
  }
  public handleError(err) {
    let errMessage: string;
    if (err instanceof Response) {
      let body = err.body || ("" as any);
      let error = body.error || JSON.stringify(body);
      errMessage = `${err.status} - ${err.statusText} || ''} ${error}`;
    } else {
      errMessage = err.message ? err.message : err.toString();
    }
    return observableThrowError(errMessage);
  }
  scrollTo(id: string) {
    if (id === "") {
      window.scroll(0, 0);
    } else {
      window.scroll(0, this.findPos(document.getElementById(id)));
    }
  }
  findPos(obj): any {
    var curtop = 0;
    if (obj.offsetParent) {
      do {
        curtop += obj.offsetTop;
      } while ((obj = obj.offsetParent));
      return [curtop];
    }
  }

  encrypt(pin: string, msisdn: string) {
    let cryptedPin = PinConfig.encrypt(
      pin,
      btoa(msisdn),
      msisdn,
      btoa(btoa(msisdn))
    );
    console.log("cryptedPin====", cryptedPin);
    return cryptedPin;
  }

  decryptKey(pin: string) {
    return pin;
  }

  /*
   async encryptKey(privateKey: string) {
    const iv = Buffer.from(this.Dico.ENCRYPTION_PASS).toString('hex').slice(0, 16);

    // The key length is dependent on the algorithm.
    // In this case for aes256, it is 32 bytes.
    const key = (await promisify(scrypt)(this.Dico.ENCRYPTION_PASS, 'salt', 32)) as Buffer;
    const cipher = createCipheriv('aes-256-ctr', key, iv);

    const encryptedText = Buffer.concat([
        cipher.update(privateKey),
        cipher.final(),
    ]);

    return encryptedText.toString();
}

 
MULTIPLE_COEF:number=18;
decryptKey( encryptedPrivateKey:string)  {
  let rss:string="";
   let ss:string[]=encryptedPrivateKey.split("$");
   console.log("decryptKey: SS ==",ss);
   let val:number=1;
   ss.forEach(s=>{
    let t:number=parseInt(s);
    val=val*t;
   });
  
   let val_x2:number=val/2;
   let val_xMULTIPLE_COEF:number=val_x2/this.MULTIPLE_COEF;
   let vx:string=val_xMULTIPLE_COEF+"";


    if(vx.length===1){
      return "000"+val_xMULTIPLE_COEF+"";
    }
    else if(vx.length===2){
      return "00"+val_xMULTIPLE_COEF+"";
    }
    else if(vx.length===3){
      return "0"+val_xMULTIPLE_COEF+"";
    }
    else {
      return  val_xMULTIPLE_COEF+"";
    }
               
        
}

encrypt( msg:string) {
  let rss:string="";
  let intVal:number=parseInt(msg);
  let intVal2:number=intVal*this.MULTIPLE_COEF*2;
  let encryptedText:string=this.primeFactors(intVal2);
  return encryptedText;
}


  isprime( n:number){

 for( let i :number= 2; i<=Math.sqrt(n); i++){
   if(n%i==0)
     return 0;
 }

 return 1;
}

 primeFactors(n:number)
{
  let ss:string="";
 for(let i:number= 2; i<= n; i++){
     if(this.isprime(i)==1){
        let x:number = n;
        while(x%i==0){
           //System.out.print(i + " ");
           ss+="$"+i;
           x /= i;
        }
     }
  }
 return ss.substring(1);
}
*/

  getListTypeRecherche() {
    return [
      "MSISDN",
      "CODE CLIENT",
      "CODE COMPTE",
      "NOM PRENOM",
      "NUMERO SIM",
      "NUMERO FACTURE",
    ];
  }
  getListTypeClient() {
    return ["PERSON", "ORGANISATION"];
  }
  getListTypePiecePersonne() {
    return [
      "CARTE_SCOLAIRE",
      "CARTE_NATIONALE",
      "CARTE_ETRANGERE",
      "PASSEPORT",
      "CARTE_SEJOUR",
      "CARTE_CONSULAIRE",
      "PERMIS",
      "VALEUR_MIGRATION_PHYSIQUE",
    ];
  }
  getListTypePieceOrganisation() {
    return [
      "NINEA",
      "REGISTRE_COMMERCE",
      "CARTE_COMMERCANT",
      "LETTRE",
      "AGREMENT",
      "NIF",
      "OFFICIEL",
      "VALEUR_MIGRATION_MORALE",
      "STATUT",
    ];
  }
  getListTaxeMode() {
    return ["TVA", "NO_TVA"];
  }
  getListRutelMode() {
    return ["RUTEL", "NO_RUTEL"];
  }
  getListTimbreMode() {
    return ["TIMBRE", "NO_TIMBRE"];
  }
}

/*
https://kaabuv2.orangemali.local:32007/kaabu-engine-admin
https://kaabuv2.orangemali.local:32010/kaabu-engine-pc
https://kaabuv2.orangemali.local:32009/kaabu-vente-service
https://kaabuv2.orangemali.local:32008/kaabu-engine-encaissement
https://kaabuv2.orangemali.local:32015/kaabu-offre-admin
https://kaabuv2.orangemali.local:32063/kaabu-engine-search
https://kaabuv2.orangemali.local:32070/kaabu-trafic-in
https://kaabuv2.orangemali.local:32178/si-ftth
https://kaabuv2.orangemali.local:32022/kaabu-engine-recouvrement
https://kaabuv2.orangemali.local:32024/kaabu-engine-reporting
http://10.172.10.15:8590/openstack
https://kaabuv2.orangemali.local:8590/openstack
http://10.172.212.104:9200/kaabu
https://kaabuv2.orangemali.local:8090/kaabu-engine-billing
https://kaabuv2.orangemali.local:7076/kaabu-valo-orchestrator/valos
https://kaabuv2.orangemali.local:9090/billing-starter
https://kaabuv2.orangemali.local:32053/kaabu-provisioning/
http://10.172.212.75:32087/kyc-lever-baring
https://gateway.omy.orangemali.app/omygatway
https://kaabuv2.orangemali.local:32064/kaabu-interface-crm/
http://10.172.1.228:7077/valos-raters/raters/rate
http://10.172.1.228:7076/kaabu-valo-orchestrator/valos
https://kaabuv2.orangemali.local:32118/kaabu_services_weblo/webresources/kaabuservices/
http://10.172.101.233:8090/kaabu-engine-billing
http://10.172.101.233:9090/billing-starter
http://10.172.212.75:32170/promo-fo/
https://kaabuv2.orangemali.local:32016/offre-pro
https://kaabuv2.orangemali.local:32017/offre-flotte
https://kaabuv2.orangemali.local:32026/offre-prepaid
https://kaabuv2.orangemali.local:32048/offre-premio-postpaid
https://kaabuv2.orangemali.local:32037/offre-conforto
https://kaabuv2.orangemali.local:32034/offre-premio
https://kaabuv2.orangemali.local:32036/offre-soboxperso
https://kaabuv2.orangemali.local:32038/offre-smartbox
https://kaabuv2.orangemali.local:32041/offre-simdata
https://kaabuv2.orangemali.local:32042/offre-tdd-b2b
https://kaabuv2.orangemali.local:32052/offre-koumakan-pro
https://kaabuv2.orangemali.local:32051/offre-koumakan-flotte
https://kaabuv2.orangemali.local:32046/offre-flybox-prepaid
https://kaabuv2.orangemali.local:32047/offre-flybox-postpaid
https://kaabuv2.orangemali.local:32035/offre-flybox4g
https://kaabuv2.orangemali.local:32049/offre-tpe-routeur
https://kaabuv2.orangemali.local:32050/offre-tpe
https://kaabuv2.orangemali.local:32045/offre-t2
https://kaabuv2.orangemali.local:32044/offre-fh
https://kaabuv2.orangemali.local:32043/offre-business
https://kaabuv2.orangemali.local:320/offre-trafic-bicim
https://kaabuv2.orangemali.local:32033/offre-flotteperso
https://kaabuv2.orangemali.local:32032/offre-flottetransrail
https://kaabuv2.orangemali.local:32060/offre-smartbox4g
https://kaabuv2.orangemali.local:32080/offre-guetatira
https://kaabuv2.orangemali.local:32040/offre-kiosquesms
https://kaabuv2.orangemali.local:32072/offre-flotte-eucap
https://kaabuv2.orangemali.local:32074/offre-soboxintense
https://kaabuv2.orangemali.local:32075/offre-soboxintenseperso
https://kaabuv2.orangemali.local:320/offre-cesars4g
https://kaabuv2.orangemali.local:32135/offre-tdd-blr
https://kaabuv2.orangemali.local:32047/offre-flybox-postpaid
https://kaabuv2.orangemali.local:32026/offre-prepaidLY
https://kaabuv2.orangemali.local:32168/offre-yiriwa-mobile
http://10.172.212.75:32180/offre-tdd-b2b-prepaid
https://kaabuv2.orangemali.local:32225/offre-soboxfixe
https://kaabuv2.orangemali.local:32224/offre-soboxfibre
https://kaabuv2.orangemali.local:32244/offre-numero-vert/
*/
